function ssvReady(f){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',f);else f();}
/* hp_00.js */
try {

  (function () {
	const el = document.getElementById("bottom-section");
	if (!el) return;
	function update() {
	  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
	  const scrollable = (document.documentElement.scrollHeight || 0) - window.innerHeight;
	  // If page is too short to scroll, keep hidden
	  if (scrollable <= 0) {
		el.style.bottom = "-200px";
		return;
	  }
	  const percent = scrollTop / scrollable;
	  // Show after scrolling 3.5% down the page
	  el.style.bottom = percent >= 0.035 ? "0px" : "-200px";
	}
	// Set initial state
	el.style.bottom = "-200px";
	window.addEventListener("scroll", update, {
	  passive: true }
						   );
	window.addEventListener("resize", update);
	window.addEventListener("load", update);
  }
  )();

} catch (e) { console.warn('ssv', e); }
/* hp_01.js */
try {

  (function(window){
	'use strict';
	var AccordionCd10 = function(selectorCd10, defaultOpenIndexCd10 = null){
	  var containerCd10 = document.querySelector(selectorCd10);
	  if(!containerCd10) return;
	  var itemsCd10 = containerCd10.querySelectorAll('.ac-cd10');
	  itemsCd10.forEach(function(itemCd10){
		var triggerCd10 = itemCd10.querySelector('.ac-trigger-cd10');
		var panelCd10   = itemCd10.querySelector('.ac-panel-cd10');
		triggerCd10.addEventListener('click', function(){
		  var isActiveCd10 = itemCd10.classList.contains('is-active-cd10');
		  itemsCd10.forEach(function(elCd10){
			elCd10.classList.remove('is-active-cd10');
			elCd10.querySelector('.ac-panel-cd10').style.height = 0;
		  }
						   );
		  if(!isActiveCd10){
			itemCd10.classList.add('is-active-cd10');
			panelCd10.style.height = panelCd10.scrollHeight + 'px';
		  }
		}
									);
		panelCd10.style.height = 0;
	  }
					   );
	  if(defaultOpenIndexCd10 !== null && itemsCd10[defaultOpenIndexCd10]){
		var defaultPanelCd10 = itemsCd10[defaultOpenIndexCd10].querySelector('.ac-panel-cd10');
		itemsCd10[defaultOpenIndexCd10].classList.add('is-active-cd10');
		defaultPanelCd10.style.height = defaultPanelCd10.scrollHeight + 'px';
	  }
	};
	window.AccordionCd10 = AccordionCd10;
  }
  )(window);
  new AccordionCd10('.accordion-container-cd10', null);

} catch (e) { console.warn('ssv', e); }
/* hp_02.js */
try {

  // TIMER DATA
  const timers = [
	{
	  id: 1, initialTime: {
		months: 1, weeks: 2, days: 3, hours: 0, minutes: 24, seconds: 26 }
	  , endDate: null }
	,
  ];
  const timerIntervals = [];
  // HIDE FUNCTION (NEW SYSTEM)
  function hideUnitBox(id) {
	const el = document.getElementById(id + "-box");
	if (el) el.classList.add("hidden");
  }
  // DISPLAY UPDATE
  function updateDisplay(index, time) {
	const suffix = timers[index].id;
	["months", "weeks", "days", "hours", "minutes", "seconds"].forEach(unit => {
	  const el = document.getElementById(unit + suffix);
	  if (el) el.textContent = String(time[unit]).padStart(2, "0");
	}
																	  );
  }
  // SET TIME
  function setCustomTime(index, m, w, d, h, min, s) {
	let now = new Date();
	let endDate = new Date(now);
	endDate.setMonth(endDate.getMonth() + m);
	endDate.setDate(endDate.getDate() + (w * 7 + d));
	endDate.setHours(endDate.getHours() + h);
	endDate.setMinutes(endDate.getMinutes() + min);
	endDate.setSeconds(endDate.getSeconds() + s);
	timers[index].endDate = endDate;
	// Start with actual initial values
	updateDisplay(index, {
	  months: m, weeks: w, days: d, hours: h, minutes: min, seconds: s }
				 );
	if (!timerIntervals[index]) {
	  timerIntervals[index] = setInterval(() => updateTimer(index), 1000);
	}
  }
  // UPDATE TIMER
  function updateTimer(index) {
	let t = timers[index];
	let now = new Date();
	let diffMs = t.endDate - now;
	if (diffMs <= 0) {
	  // Reset to initial time
	  setCustomTime(index, t.initialTime.months, t.initialTime.weeks, t.initialTime.days, t.initialTime.hours, t.initialTime.minutes, t.initialTime.seconds);
	  return;
	}
	let diff = Math.floor(diffMs / 1000);
	let months = Math.floor(diff / (30 * 24 * 60 * 60));
	diff -= months * (30 * 24 * 60 * 60);
	let weeks = Math.floor(diff / (7 * 24 * 60 * 60));
	diff -= weeks * (7 * 24 * 60 * 60);
	let days = Math.floor(diff / (24 * 60 * 60));
	diff -= days * (24 * 60 * 60);
	let hours = Math.floor(diff / 3600);
	diff -= hours * 3600;
	let minutes = Math.floor(diff / 60);
	let seconds = diff % 60;
	updateDisplay(index, {
	  months, weeks, days, hours, minutes, seconds }
				 );
  }
  // INITIALIZE ALL TIMERS
  timers.forEach((t, index) => {
	setCustomTime(index, t.initialTime.months, t.initialTime.weeks, t.initialTime.days, t.initialTime.hours, t.initialTime.minutes, t.initialTime.seconds);
  }
				);
  // HIDE ITEMS (AS YOU REQUESTED)
  hideUnitBox("weeks1");
  hideUnitBox("months1");
  hideUnitBox("days1");

} catch (e) { console.warn('ssv', e); }
/* hp_03.js */
try {

  class Slider {
	constructor(container, options = {
	  autoplay: false, autoplayDelay: 3000 }
			   ) {
	  this.container = container;
	  this.mainImageContainer = container.querySelector('.main-image');
	  this.thumbnailContainer = container.querySelector('.thumbnail-container');
	  this.thumbnails = container.querySelectorAll('.thumbnail');
	  this.imageCounter = container.querySelector('.image-counter');
	  this.prevButton = container.querySelector('.prev-button');
	  this.nextButton = container.querySelector('.next-button');
	  this.thumbPrevButton = container.querySelector('.thumb-prev-button');
	  this.thumbNextButton = container.querySelector('.thumb-next-button');
	  this.currentIndex = 0;
	  this.isDragging = false;
	  this.startX = 0;
	  this.scrollLeft = 0;
	  this.lastX = 0;
	  this.velocity = 0;
	  this.animationFrame = null;
	  this.mainIsDragging = false;
	  this.mainDragStart = 0;
	  this.autoplay = options.autoplay;
	  this.autoplayDelay = options.autoplayDelay;
	  this.autoplayTimer = null;
	  this.init();
	  if (this.autoplay) this.startAutoplay();
	}
	getThumbnailWidth() {
	  return this.thumbnailContainer.querySelector('.thumbnail').offsetWidth + 10;
	}
	getMainImageUrl(url) {
	  return url.replace('w=100&h=100', 'w=800&h=500');
	}
	updateCounter() {
	  this.imageCounter.textContent = `${this.currentIndex + 1}
/${this.thumbnails.length}
`;
	}
	updateSlider(index, direction = 'right') {
	  if (index < 0) index = this.thumbnails.length - 1;
	  if (index >= this.thumbnails.length) index = 0;
	  this.currentIndex = index;
	  const newImg = document.createElement('img');
	  newImg.src = this.getMainImageUrl(this.thumbnails[this.currentIndex].src);
	  newImg.alt = this.thumbnails[this.currentIndex].alt;
	  newImg.classList.add('mainImage', direction === 'right' ? 'slide-right' : 'slide-left');
	  const currentImg = this.mainImageContainer.querySelector('.mainImage.active');
	  if (currentImg) {
		currentImg.classList.remove('active');
		currentImg.classList.add(direction === 'right' ? 'slide-left' : 'slide-right');
	  }
	  this.mainImageContainer.appendChild(newImg);
	  newImg.offsetHeight;
	  newImg.classList.add('active');
	  newImg.classList.remove(direction === 'right' ? 'slide-right' : 'slide-left');
	  setTimeout(() => {
		if (currentImg) currentImg.remove();
		this.initMainDrag();
	  }
				 , 500);
	  this.thumbnails.forEach(t => t.classList.remove('active'));
	  this.thumbnails[this.currentIndex].classList.add('active');
	  const thumbWidth = this.getThumbnailWidth();
	  const scrollPos = thumbWidth * this.currentIndex - (this.thumbnailContainer.clientWidth / 2) + (thumbWidth / 2);
	  this.thumbnailContainer.scrollTo({
		left: scrollPos, behavior: 'smooth' }
									  );
	  this.updateCounter();
	  if (this.autoplay) this.restartAutoplay();
	}
	startThumbnailDrag() {
	  const tc = this.thumbnailContainer;
	  const startDrag = (x) => {
		this.isDragging = true;
		this.startX = x - tc.offsetLeft;
		this.scrollLeft = tc.scrollLeft;
		this.lastX = this.startX;
		this.velocity = 0;
		cancelAnimationFrame(this.animationFrame);
		tc.style.cursor = 'grabbing';
	  };
	  const moveDrag = (x) => {
		if (!this.isDragging) return;
		const diff = x - this.lastX;
		this.velocity = diff;
		tc.scrollLeft = this.scrollLeft - (x - this.startX) * 1.5;
		this.lastX = x;
	  };
	  const endDrag = () => {
		this.isDragging = false;
		tc.style.cursor = 'grab';
		const applyInertia = () => {
		  if (Math.abs(this.velocity) < 0.1) return;
		  tc.scrollLeft -= this.velocity;
		  this.velocity *= 0.95;
		  this.animationFrame = requestAnimationFrame(applyInertia);
		};
		this.animationFrame = requestAnimationFrame(applyInertia);
	  };
	  // Mouse events
	  tc.addEventListener('mousedown', e => {
		e.preventDefault();
		startDrag(e.pageX);
	  }
						 );
	  tc.addEventListener('mousemove', e => moveDrag(e.pageX));
	  tc.addEventListener('mouseup', endDrag);
	  tc.addEventListener('mouseleave', endDrag);
	  // Touch events
	  tc.addEventListener('touchstart', e => {
		startDrag(e.touches[0].pageX);
		e.stopPropagation();
	  }
						  , {
		passive: false }
						 );
	  tc.addEventListener('touchmove', e => {
		moveDrag(e.touches[0].pageX);
		e.stopPropagation();
		e.preventDefault();
	  }
						  , {
		passive: false }
						 );
	  tc.addEventListener('touchend', e => {
		endDrag();
		e.stopPropagation();
	  }
						  , {
		passive: false }
						 );
	}
	initMainDrag() {
	  const main = this.mainImageContainer.querySelector('.mainImage');
	  const dragStart = (x) => {
		this.mainIsDragging = true;
		this.mainDragStart = x;
	  }
	  const dragMove = (x) => {
		if (!this.mainIsDragging) return;
		const diff = x - this.mainDragStart;
		if (Math.abs(diff) > 50) {
		  if (diff < 0) this.updateSlider(this.currentIndex + 1, 'right');
		  else this.updateSlider(this.currentIndex - 1, 'left');
		  this.mainIsDragging = false;
		}
	  }
	  const dragEnd = () => {
		this.mainIsDragging = false;
	  }
	  // Mouse events
	  main.addEventListener('mousedown', e => dragStart(e.pageX));
	  main.addEventListener('mousemove', e => dragMove(e.pageX));
	  main.addEventListener('mouseup', dragEnd);
	  main.addEventListener('mouseleave', dragEnd);
	  // Touch events
	  main.addEventListener('touchstart', e => dragStart(e.touches[0].pageX));
	  main.addEventListener('touchmove', e => dragMove(e.touches[0].pageX));
	  main.addEventListener('touchend', dragEnd);
	}
	startAutoplay() {
	  this.autoplayTimer = setInterval(() => this.updateSlider(this.currentIndex + 1, 'right'), this.autoplayDelay);
	}
	stopAutoplay() {
	  clearInterval(this.autoplayTimer);
	  this.autoplayTimer = null;
	}
	restartAutoplay() {
	  if (this.autoplay) {
		this.stopAutoplay();
		this.startAutoplay();
	  }
	}
	init() {
	  // Thumbnail click
	  this.thumbnails.forEach((t, i) => t.addEventListener('click', () => {
		const dir = i > this.currentIndex ? 'right' : 'left';
		this.updateSlider(i, dir);
	  }
														  ));
	  // Main prev/next buttons
	  this.nextButton.addEventListener('click', () => this.updateSlider(this.currentIndex + 1, 'right'));
	  this.prevButton.addEventListener('click', () => this.updateSlider(this.currentIndex - 1, 'left'));
	  // Thumbnail nav buttons
	  this.thumbNextButton.addEventListener('click', e => {
		e.stopPropagation();
		const w = this.getThumbnailWidth();
		const maxScroll = this.thumbnailContainer.scrollWidth - this.thumbnailContainer.clientWidth;
		let ns = this.thumbnailContainer.scrollLeft + w;
		if (ns > maxScroll) ns = maxScroll;
		this.thumbnailContainer.scrollTo({
		  left: ns, behavior: 'smooth' }
										);
		this.updateSlider(this.currentIndex + 1, 'right');
	  }
										   );
	  this.thumbPrevButton.addEventListener('click', e => {
		e.stopPropagation();
		const w = this.getThumbnailWidth();
		let ns = this.thumbnailContainer.scrollLeft - w;
		if (ns < 0) ns = 0;
		this.thumbnailContainer.scrollTo({
		  left: ns, behavior: 'smooth' }
										);
		this.updateSlider(this.currentIndex - 1, 'left');
	  }
										   );
	  this.startThumbnailDrag();
	  this.updateCounter();
	  this.initMainDrag();
	}
  }
  // Initialize sliders
  document.querySelectorAll('.slider-container').forEach((c, index) => {
	if (index === 0) {
	  new Slider(c, {
		autoplay: false, autoplayDelay: 3000 }
				);
	  // Slider 1
	}
	else if (index === 1) {
	  new Slider(c, {
		autoplay: false }
				);
	  // Slider 2
	}
	else {
	  new Slider(c, {
		autoplay: true, autoplayDelay: 5000 }
				);
	}
  }
														);

} catch (e) { console.warn('ssv', e); }
/* hp_04.js */
try {

  new Swiper('.tp-swiper', {
	slidesPerView: 'auto',
	spaceBetween: 20,
	navigation: {
	  nextEl: '.tp-next',
	  prevEl: '.tp-prev',
	}
	,
	watchOverflow: true,
  }
			);

} catch (e) { console.warn('ssv', e); }
/* hp_05.js */
try {

  /* PREVENT MOBILE FLICKER — runs immediately before render */
  (function() {
	var style = document.createElement('style');
	style.innerHTML = '#review-modal{display:none !important;}';
	document.head.appendChild(style);
  }
  )();

} catch (e) { console.warn('ssv', e); }
/* hp_06.js */
try {

  ssvReady(function () {
	const modal = document.getElementById('review-modal');
	/* Keep modal hidden initially */
	modal.style.setProperty('display', 'none', 'important');
	const modalContent = modal.querySelector('.modal-content');
	const avatar = modal.querySelector('.avatar');
	const nameEl = modal.querySelector('.name');
	const extraEl = modal.querySelector('.extra');
	const modalStars = modal.querySelector('.rating img');
	const modalDate = modal.querySelector('.rating time');
	const modalTitle = modal.querySelector('.review-title');
	const modalText = modal.querySelector('.review-text');
	const modalBadges = modal.querySelector('.badges');
	function openModal(btn) {
	  avatar.textContent = btn.dataset.initials;
	  nameEl.textContent = btn.dataset.name;
	  extraEl.textContent = btn.dataset.country + " • " + btn.dataset.reviews;
	  const card = btn.closest('.tp-card');
	  if (card) {
		const cardAvatar = card.querySelector('.tp-avatar');
		if (cardAvatar) {
		  avatar.style.backgroundColor =
			window.getComputedStyle(cardAvatar).backgroundColor;
		}
	  }
	  modalDate.textContent = btn.dataset.date;
	  modalTitle.textContent = btn.dataset.title;
	  modalText.textContent = btn.dataset.fulltext;
	  modalBadges.innerHTML =
		'<span>' + btn.dataset.date + '</span><span>Unaufgeforderte Bewertung</span>';
	  /* IMPORTANT: override the !important hide */
	  modal.style.setProperty('display', 'flex', 'important');
	  modalContent.style.animation = 'none';
	  void modalContent.offsetWidth;
	  modalContent.style.animation = 'slideUp 0.3s ease-out';
	}
	/* See more buttons */
	document.querySelectorAll('.see-more').forEach(function(btn) {
	  btn.addEventListener('click', function() {
		openModal(btn);
	  }
						  );
	}
												  );
	/* Close button */
	modal.querySelector('.close').addEventListener('click', function() {
	  modal.style.setProperty('display', 'none', 'important');
	}
												  );
	/* Click outside */
	window.addEventListener('click', function(e) {
	  if (e.target === modal) {
		modal.style.setProperty('display', 'none', 'important');
	  }
	}
						   );
	/* Escape key */
	document.addEventListener('keydown', function(e) {
	  if (e.key === 'Escape') {
		modal.style.setProperty('display', 'none', 'important');
	  }
	}
							 );
  }
						   );

} catch (e) { console.warn('ssv', e); }
/* hp_07.js */
try {

  document.addEventListener('click', function(e) {
	var btn = e.target.closest('#cc-id-DuEoOqFM3i5T');
	if (btn) {
	  /* STOP Checkout Champ routing */
	  e.preventDefault();
	  e.stopImmediatePropagation();
	  /* Your modal close logic */
	  var modal = document.getElementById('review-modal');
	  if (modal) {
		modal.style.setProperty('display','none','important');
	  }
	}
  }
							, true);

} catch (e) { console.warn('ssv', e); }
/* hp_08.js */
try {

  document.addEventListener('click', function(e) {
	var btn = e.target.closest('#cc-id-YsGN4gjXzNN6, #cc-id-vicKPltSoBgs');
	if (btn) {
	  /* Stop Checkout Champ routing only */
	  e.preventDefault();
	  /* Remove Checkout Champ routing attributes dynamically */
	  btn.removeAttribute('onclick');
	  btn.removeAttribute('action');
	  btn.removeAttribute('data-id');
	}
  }
							, true);

} catch (e) { console.warn('ssv', e); }
/* hp_09.js */
try {

  ssvReady(function () {
	const dateElement = document.querySelector(".today-date");
	const today = new Date();
	const options = {
	  year: "numeric", 
	  month: "long", 
	  day: "numeric" 
	};
	dateElement.textContent = today.toLocaleDateString("de-DE", options);
  }
						   );

} catch (e) { console.warn('ssv', e); }